export default __webpack_public_path__ + "static/media/homeIcon.d72d27d3.svg";